<template>
  <div class="flex justify-center items-center h-lvh pb-2 text-center">
    <div class="px-3 m-0 w-96">
      <div class="h-content m-auto">
        <p class="text-semibold text-brand-700 my-3">404 Error</p>
        <p class="font-semibold text-4xl text-base-black my-3">We lost this page</p>
        <p class="text-grey-light-400 my-3">
          We searched high and low, but couldn't find what you're looking for. Let's find a better place for you to go.
        </p>
        <button
          variant="outline-secondary"
          class="bg-brand-600 rounded w-full relative h-10 text-base-white hover:bg-brand-700 disabled:opacity-60 disabled:bg-brand-600 mt-4"
          @click="goHome"
        >
          Go Home
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { createWarning } from '@/utils/monitoring.utils';
import { onMounted } from 'vue';
import { CUSTOMER_UI_URL } from '../config';

onMounted(() => {
  createWarning('404 page accessed');
});

const goHome = () => {
  window.location.href = `${CUSTOMER_UI_URL}/dashboard/`;
};
</script>
